import { EnumsFilter,EnumsService, TenantFilter, TenantService, tlISODateTimeToLocalNoSecondsString, NotificationSendService, BaseTLDetailComponent, AxiosResponse, RightHelper, Watch, EventRoleFilter,EventRoleService, RoleService, RoleFilter, NotificationTemplateService, NotificationTemplateFilter, NotificationSendPortalFilter } from "../../../Infrastructure/CorBase/CoreBase";

interface iTenant {
	id: number;
	name: string;
	identifier: string;
	description: string;
	idStateText: string;
};

interface iRole {
	id: number;
	name: string;
	identifier: string;
	description: string;
};

interface iUser {
	id: number;
	user: string;
	personName: string;
};

export default abstract class NotificationPortalDetailBase extends BaseTLDetailComponent {

	notificationTemplateService: NotificationTemplateService = new NotificationTemplateService();
	notificationSendService: NotificationSendService = new NotificationSendService();
	tenantService: TenantService = new TenantService();
	roleService: RoleService = new RoleService();
	enumService: EnumsService = new EnumsService();

	templateList: any[] = [];
	templateBody = "";
	templateSubject = "";
	templateEmail = false;
	templatePortal = false;

	isEditReceiverDetail = true;//zmenit
	//tenants: any[] = [];
	tenantsAll: iTenant[] = [];
	users: iUser[] = [];
	rolesAll: iRole[] = [];
	isBusyTenant = false;
	searchAll = [{ id: 1, text: 'test', identifier: '' }];

	prepareAfterLoad(inputText: string) {
		for (var i = 0; i < this.searchAll.length; i++) {
			inputText = inputText.split('@' + this.searchAll[i].identifier).join('@' + this.searchAll[i].text);
		}
		return inputText;
	}

	initEnum() {
		this.searchAll = [];
		var filter = new EnumsFilter(this.$store.state.idTenant, 'ENU_COR_NotificationTemplate_IvyScreen');
		this.enumService.getAllByFilter(filter).then(res => {
			for (var i = 0; i < res.data.length; i++) {
				this.searchAll.push({ id: res.data[i].id, text: res.data[i].name, identifier: res.data[i].identifier });
			}
		});
	}

	 areSetsEqual<T>(setA: Set<T>, setB: Set<T>): boolean {
		if (setA.size !== setB.size) return false; // Pokud mají různou velikost, nejsou stejné

		for (let item of setA) {
			if (!setB.has(item)) return false; // Pokud setB neobsahuje prvek z setA, nejsou stejné
		}

		return true; // Všechny prvky setA jsou v setB a mají stejnou velikost, jsou stejné
}

	lastTenants: Set<number> = new Set();
	lastRoles: Set<number> = new Set();
	lastAllUsers = true;
	lastAllRoles = false;
	getAllAddres() {
		var tenantsFilter = this.formData.tenants.map(c => c.id);
		var rolesFilter = this.formData.roles.map(c => c.id);

		var tenantsSet = new Set<number>(tenantsFilter);
		var rolesSet = new Set<number>(rolesFilter);


		if (!this.areSetsEqual(this.lastTenants, tenantsSet) || !this.areSetsEqual(this.lastRoles, rolesSet) || this.lastAllUsers != this.formData.allUserSend || this.lastAllRoles != this.formData.useRoleToSend) {		
			var tenantsFilterD = this.formData.allUserSend ?  tenantsFilter:[] ;
			var roleFilterD = this.formData.useRoleToSend ? rolesFilter : [];
			
			var filter = new NotificationSendPortalFilter(tenantsFilterD.join(','), roleFilterD.join(','));
			this.lastAllUsers = this.formData.allUserSend;
			this.lastAllRoles = this.formData.useRoleToSend;
			this.lastTenants = new Set(tenantsFilter);
			this.lastRoles = new Set(rolesFilter);
			this.notificationSendService.getUserSendNotification(filter).then(res => {
				this.users = res.data;
			});
		}
	}

	fetchVariantList() {
		//let filter: NotificationTemplateFilter = new NotificationTemplateFilter(this.$store.state.idTenant, null, 'ENU_NotificationTemplate_IvyScreen_Template');
		let filter: NotificationTemplateFilter = new NotificationTemplateFilter(null, null, 'ENU_NotificationTemplate_IvyScreen_Template');
		this.notificationTemplateService.getAllByFilter(filter).then((response) => {
			this.templateList = [];
			for (var i = 0; i < response.data.length; i++) {
				this.templateList.push({
					value: response.data[i].id, text: response.data[i].identifier, subject: response.data[i].subjectDtb, body: response.data[i].bodyDtb
					, viaEmail: response.data[i].viaEmail, viaPortal: response.data[i].viaPortal				});
			}
		});
	}

	initTenant() {
		var tenantFilter = new TenantFilter(false);
		this.tenantService.getAllByFilter(tenantFilter).then(res => {
			this.tenantsAll = [];
			(res.data as Array<any>).forEach(item => {
				if (!this.formData.tenants.some(c => c.id == item.id)) {
					this.tenantsAll.push(item);
				}
			});
		
		});
	}


	createBase() {
		this.fetchVariantList();
		this.initEnum();
	}

	@Watch('formData.idTemplate')
	changeIdTemplate(idTemplate: number, idTemplateOld: number) {
		if (idTemplate != idTemplateOld && idTemplate > 0) {
			var select = this.templateList.filter((c: any) => c.value == idTemplate)[0];
			this.templateSubject = this.prepareAfterLoad(select.subject);
			this.templateBody = this.prepareAfterLoad(select.body);
			this.templateEmail = select.viaEmail;
			this.templatePortal = select.viaPortal;
		}
	}


	formData = {
		idTemplate: 0 as number | null,
		subject: '' as string,
		body: '' as string,
		ownNotification: false as boolean,
		allUserSend: false as boolean,
		viaEmail: false as boolean,
		viaPortal: false as boolean,
		tenants: [] as iTenant[],
		useRoleToSend: false as boolean,
		roles: [] as iRole[],
		idUser: this.$store.state.idUser,
		saveTemplate: false as boolean,	
		rolesId: [] as number[],
		tenantsId: [] as number[],
		idTenant: this.$store.state.idTenant as number | null,
	}

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		return super.NoCall();
	}

	protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return super.NoCall()
	}

	protected refreshItems(items: any, refreshData: any): any {
		return items;
	}

	protected processResponse(response: AxiosResponse<any>): void {

	}


	doAction() {
		super.doCRUDActionWithInfoMessage(this.$t('notificationPortal.messageNew').toString(), this.$t('notificationPortal.messageEdit').toString(), this.$t('notificationPortal.messageDelete').toString());
	}

	protected updateObject(): Promise<AxiosResponse<any>> {
		return super.NoCall();
		//return this.notificationSendService.update(this.objectId, this.formData);
	}

	protected createObject(): Promise<AxiosResponse<any>> {
		return super.NoCall();
		//return this.notificationSendService.create(this.formData);
	}

	protected deleteObject(): Promise<AxiosResponse<any>> {
		return super.NoCall();
		//return this.notificationSendService.delete(this.objectId);
	}

	fieldsUser = [	
		//{ key: 'id', label: this.$t('notificationPortal.usersId'), trans: 'notificationPortal.usersId', sortable: true, class: 'text-center', optional: false, visible: true },
		//{ key: 'idPerson', label:'idPerson', trans: 'notificationPortal.usersId', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'login', label: this.$t('notificationPortal.usersLogin'), trans: 'notificationPortal.usersLogin', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'personName', label: this.$t('notificationPortal.usersName'), trans: 'notificationPortal.usersName', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'tenantName', label: this.$t('notificationPortal.usersTenant'), trans: 'notificationPortal.usersTenant', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'personEmail', label: this.$t('notificationPortal.usersEmail'), trans: 'notificationPortal.usersEmail', sortable: true, class: 'text-center', optional: false, visible: true },

	];

	fieldsTenant = [
		//{ key: 'id', label: this.$t('taskDetail.fieldId'), trans: 'taskDetail.fieldId', sortable: false, class: 'text-center helpPaddingLeft30' },
		{ key: 'identifier', label: this.$t('notificationPortal.tenantModalIdentification'), trans: 'notificationPortal.tenantModalIdentification', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'name', label: this.$t('notificationPortal.tenantModalName'), trans: 'notificationPortal.tenantModalName', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'description', label: this.$t('notificationPortal.tenantModalDescription'), trans: 'notificationPortal.tenantModalDescription', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'idStateText', label: this.$t('notificationPortal.tenantModalState'), trans: 'notificationPortal.tenantModalState', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'actions', label: '', class: 'text-right' }
	];

	fieldsTenantModal = [
		//{ key: 'id', label: this.$t('taskDetail.fieldId'), trans: 'taskDetail.fieldId', sortable: false, class: 'text-center helpPaddingLeft30', visible: false },
		{ key: 'identifier', label: this.$t('notificationPortal.tenantModalIdentification'), trans: 'notificationPortal.tenantModalIdentification', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'name', label: this.$t('notificationPortal.tenantModalName'), trans: 'notificationPortal.tenantModalName', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'description', label: this.$t('notificationPortal.tenantModalDescription'), trans: 'notificationPortal.tenantModalDescription', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'idStateText', label: this.$t('notificationPortal.tenantModalState'), trans: 'notificationPortal.tenantModalState', sortable: true, class: 'text-center', optional: false, visible: true },
		//{ key: 'idStateIdentifier', label: 'Neviditelny', sortable: false, class: 'text-left', optional: true, visible: false, show: false },
	];

	filtersTenantModal = [
		{ key: 'identifier', label: this.$t('tenant.filterIdentif'), trans: 'tenant.filterIdentif', selected: false, value: null, type: 'text', refItem: 'identifier', lang: this.$store.state.currentLanguage },
		{ key: 'name', label: this.$t('tenant.filterName'), trans: 'tenant.filterName', selected: false, value: null, type: 'text' },
		//{ key: 'shortName', label: this.$t('tenant.fieldAbbreviation'), trans: 'tenant.fieldAbbreviation', selected: false, value: null, type: 'text' },
		{ key: 'description', label: this.$t('tenant.filterDescription'), trans: 'tenant.filterDescription', selected: false, value: null, type: 'text' },


	];


	showModalTenantsBase() {
		this.initTenant();
		this.$bvModal.show('tenantModal');
	}

	selectedAddTenantBase(items: any) {
		var selectedTenant = this.tenantsAll.filter(c => items.includes(c.id));	
		selectedTenant.forEach(item => {
			if (this.formData.tenants.filter(c => c.id == item.id).length == 0) {
				this.formData.tenants.push(item);
			};
		});
	}

	deleteTenantBase(item: any) {
		this.formData.tenants = this.formData.tenants.filter(c => c.id != item);
		this.allowSendBase();
	}

	goBackTenantBase() {
		this.formData.tenants = [];
	}

	goBackRoleBase() {
		this.formData.roles = [];
	}

	showModalRoleBase() {
		this.initRole();
		this.$bvModal.show('roleModal');
	}

	deleteRoleBase(item: any) {
		this.formData.roles = this.formData.roles.filter(c => c.id != item);
	}

	initRole() {
		var roleFilter = new RoleFilter();
		this.roleService.getAllByFilter(roleFilter).then(res => {
			this.rolesAll = [];
			(res.data as Array<any>).forEach(item => {
				if (!this.formData.roles.some(c => c.id == item.id)) {
					item.isEditableRow = true;
					this.rolesAll.push(item);
				}
			});

		});
	}

	selectedAddRoleBase(items: any) {
		var selectedRole = this.rolesAll.filter(c => items.includes(c.id));
		selectedRole.forEach(item => {
			if (this.formData.roles.filter(c => c.id == item.id).length == 0) {
				this.formData.roles.push(item);
			};
		});
	}



	fieldsRole = [
		//{ key: 'id', label: this.$t('taskDetail.fieldId'), trans: 'taskDetail.fieldId', sortable: false, class: 'text-center helpPaddingLeft30' },
		{ key: 'identifier', label: this.$t('notificationPortal.tenantModalIdentification'), trans: 'notificationPortal.tenantModalIdentification', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'name', label: this.$t('notificationPortal.tenantModalName'), trans: 'notificationPortal.tenantModalName', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'description', label: this.$t('notificationPortal.tenantModalDescription'), trans: 'notificationPortal.tenantModalDescription', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'actions', label: '', class: 'text-right' }
	];

	fieldsRoleModal = [
		//{ key: 'id', label: this.$t('taskDetail.fieldId'), trans: 'taskDetail.fieldId', sortable: false, class: 'text-center helpPaddingLeft30', visible: false },
		{ key: 'identifier', label: this.$t('notificationPortal.tenantModalIdentification'), trans: 'notificationPortal.tenantModalIdentification', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'name', label: this.$t('notificationPortal.tenantModalName'), trans: 'notificationPortal.tenantModalName', sortable: true, class: 'text-center', optional: false, visible: true },
		{ key: 'description', label: this.$t('notificationPortal.tenantModalDescription'), trans: 'notificationPortal.tenantModalDescription', sortable: true, class: 'text-center', optional: false, visible: true },
	
	];

	filtersRoleModal = [
		{ key: 'identifier', label: this.$t('tenant.filterIdentif'), trans: 'tenant.filterIdentif', selected: false, value: null, type: 'text', refItem: 'identifier', lang: this.$store.state.currentLanguage },
		{ key: 'name', label: this.$t('tenant.filterName'), trans: 'tenant.filterName', selected: false, value: null, type: 'text' },
		//{ key: 'shortName', label: this.$t('tenant.fieldAbbreviation'), trans: 'tenant.fieldAbbreviation', selected: false, value: null, type: 'text' },
		{ key: 'description', label: this.$t('tenant.filterDescription'), trans: 'tenant.filterDescription', selected: false, value: null, type: 'text' },


	];

	allowSendBase() {
		var isSelectUser = !this.formData.allUserSend || this.formData.tenants.length > 0;
		var isSelectRole = !this.formData.useRoleToSend || this.formData.roles.length > 0;
		var isSelectType = this.formData.viaEmail || this.formData.viaPortal;
		var result = ((this.formData.body.trim() != "" && this.formData.subject.trim() != "" && this.formData.ownNotification)
			|| (this.formData.idTemplate != 0 && this.formData.idTemplate != null && !this.formData.ownNotification))
			&& isSelectUser && isSelectRole && isSelectType && this.users.length>0; 
		
		this.getAllAddres();
		return result;
	}


	sendBase(saveTemplate: boolean) {
		this.formData.saveTemplate = saveTemplate;
	
		this.formData.rolesId = this.formData.roles.map(c => c.id);
		this.formData.tenantsId = this.formData.tenants.map(c => c.id);
		this.notificationSendService.sendAllNotificationPortal(0, this.formData).then(res => {
			if (saveTemplate) {
				this.fetchVariantList();
			}
		});
	}

}
